'use client';

import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { useEffect } from 'react';

import { useOverlay } from '@flipster/overlay';

import { earnSunsetBunja } from '../bunja';
import { EarnSunsetModal } from './index';

export const EarnSunsetModalHost = () => {
  const overlay = useOverlay();
  const { shouldShowSunsetModalAtom } = useBunja(earnSunsetBunja);
  const shouldShow = useAtomValue(shouldShowSunsetModalAtom);

  useEffect(() => {
    if (!shouldShow) return;
    const { close } = overlay.open(({ isOpen, onClose, unmount }) => (
      <EarnSunsetModal isOpen={isOpen} onClose={onClose} onExit={unmount} />
    ));
    return close;
  }, [overlay, shouldShow]);

  return null;
};
